import * as React from 'react';
import * as Auth from '../../libs/auth';

export const LOGIN_PAGE_ROUTE = '/login';

interface IProps {
  redirectUrl?: string;
  storeRedirectUrl: (url: string) => void;
}

class LoginPage extends React.Component<IProps> {
  public async componentDidMount() {
    if (this.props.redirectUrl !== undefined) {
      this.props.storeRedirectUrl(this.props.redirectUrl);
    }

    const url = await Auth.requestAuthorisationURL();
    window.location.replace(url);
  }

  public render() {
    return <div>redirecting...</div>;
  }
}

export default LoginPage;
